import { darken, mode, whiten } from "@chakra-ui/theme-tools"

export const button = {
  variants: {
    primary: {
      bg: "primary",
      color: "white",
      fontWeight: "400",
      _disabled: {
        color: "neutral.300"
      }
    },
    secondary: {
      bg: "transparent",
      color: "black",
      fontWeight: "400",
      border: "2px solid",
      _disabled: {
        color: "neutral.300"
      }
    },
    tertiary: {
      bg: "transparent",
      color: "black",
      fontWeight: "400",
      transition: "all 200ms ease",
      _hover: {
        bg: mode(whiten("neutral.50", 20), darken("neutral.50", 20))
      },
      _focus: {
        boxShadow: "0 0 1px 2px rgba(0, 0, 177, 1), 0 1px 1px rgba(0, 0, 0, .15)"
      },
      _disabled: {
        color: "neutral.300"
      }
    }
  }
}
